import React from 'react';

import styles from '../Markdown.pcss';

/* Ignore all list ordering */
const MarkdownList = (props: {
    children: React.ReactNode;
    depth: number;
    ordered: boolean;
    start?: number;
    tight: true;
}) => <ul className={styles.list}>{props.children}</ul>;

export default MarkdownList;
